module.exports = __webpack_public_path__ + "1e2d14d48b8e258e228d7e85ba831211.svg";